export const USER_INFO_URL = '/api/dsp/user/user';
export const USER_SET_LANGUAGE_URL = '/api/dsp/user/set_language';

// 配置相关
export const CONFIG_DICTS = '/api/dsp/config/dicts';
export const CONFIG_AD_STYLE_LIST = '/api/dsp/config/ad_style_list';
export const CONFIG_INDUSTRY_LIST_URL = '/api/dsp/config/industry_list';
export const CONFIG_CERTIFICATE_LIST_URL = '/api/dsp/config/certificate_list';

// 登录相关
export const BASE_LOGIN_URL = '/api/dsp/base/login';
export const BASE_LOGOUT_URL = '/api/dsp/base/logout';
export const BASE_GET_CODE_URL = '/api/dsp/base/get_code';
export const BASE_GRAPH_URL = '/api/dsp/base/graph';
export const BASE_ADSET_LIST_URL = '/api/dsp/base/adset_list';
export const BASE_MAIN_URL = '/api/dsp/base/main';

// 文件转发接口
export const REMOTE_FILE_URL = '/api/fe/file';

// 用户信息
export const ADVERTISER_DETAIL_URL = '/api/dsp/ad_account/info';
export const AD_ACCOUNT_LIST = '/api/dsp/ad_account/list';
export const AD_ACCOUNT_UPDATE_URL = '/api/dsp/ad_account/update';
export const AD_ACCOUNT_LIST_ALL_URL = '/api/dsp/ad_account/list_all';

// oauth授权
export const OPEN_API_OAUTH_URL = '/api/dsp/openapi/oauth';

// 广告系列
export const CAMPAIGN_LIST_URL = '/api/dsp/campaign/list';
export const CAMPAIGN_DATA_LIST_URL = '/api/dsp/campaign/data_list';
export const CAMPAIGN_UPDATE_STATUS_URL = '/api/dsp/campaign/update_status';
export const CAMPAIGN_UPDATE_BUDGET_URL = '/api/dsp/campaign/update_budget';
export const CAMPAIGN_UPDATE_URL = '/api/dsp/campaign/update';

// 广告组
export const ADSET_LIST_URL = '/api/dsp/adset/list';
export const ADSET_DATA_LIST_URL = '/api/dsp/adset/data_list';
export const ADSET_UPDATE_STATUS_URL = '/api/dsp/adset/update_status';
export const ADSET_UPDATE_URL = '/api/dsp/adset/update';
export const ADSET_UPDATE_BID_BUDGET_URL = '/api/dsp/adset/update_bid_budget';
export const ADSET_BATCH_UPDATE_URL = '/api/dsp/adset/batch_update';

// 广告
export const AD_LIST_URL = '/api/dsp/ad/list';
export const AD_DATA_LIST_URL = '/api/dsp/ad/data_list';
export const AD_UPDATE_STATUS_URL = '/api/dsp/ad/update_status';
export const AD_UPDATE_URL = '/api/dsp/ad/update';
export const AD_ADD_URL = '/api/dsp/ad/add';
export const AD_BATCH_ADD_URL = '/api/dsp/ad/batch_add';
export const AD_EXTRACT_COVER_URL = '/api/dsp/ad/extract_cover';
export const AD_PREVIEW_UPDATE_URL = '/api/dsp/ad/preview/add_or_update';
export const AD_PREVIEW_LIST_URL = '/api/dsp/ad/preview/list';
export const AD_RECENT_KEYWORDS = '/api/dsp/ad/list_words';
export const AD_CHECK_NUM = '/api/dsp/ad/check_num';

// 程序化创意广告
export const PROCEDURAL_CREATIVITY_LIST_URL = '/api/dsp/procedural_creativity/list';
export const PROCEDURAL_CREATIVITY_UPDATE_URL = '/api/dsp/procedural_creativity/update';

// 新程序化创意广告
/** 新程序化创意 - 广告列表（获取提交的广告表单） */
export const PRO_AD_LIST = '/api/dsp/prog_creative/list';
/** 程序化创意数据列表 */
export const PRO_CREATIVITY_LIST = '/api/dsp/prog_creative_material/data_list';
/** 程序化创意审核列表 */
export const PRO_CREATIVITY_AUDIT_LIST = '/api/dsp/prog_creative_material/list';

// 应用管理
export const APP_LINK_EXTRACT_URL = '/api/dsp/app/link_extract';
export const APP_ADD_URL = '/api/dsp/app/add';
export const APP_UPDATE_URL = '/api/dsp/app/update';
export const APP_LIST_URL = '/api/dsp/app/list';
export const APP_DATA_LIST_URL = '/api/dsp/app/data_list';
export const APP_ATTRIBUTION_LIST_URL = '/api/dsp/app/attribution_list';
export const APP_ATTRIBUTION_GRAPH_URL = '/api/dsp/app/attribution_graph';
export const APP_ATTRIBUTION_UPDATE_URL = '/api/dsp/app/attribution_update';
// 应用管理-应用商店分组列表
export const APP_GROUP_LIST_URL = '/api/dsp/app/group_list';

// 网页事件
export const WEBPAGE_LINK_EXTRACT_URL = '/api/dsp/webpage/link_extract';
export const WEBPAGE_ADD_URL = '/api/dsp/webpage/add';
export const WEBPAGE_UPDATE_URL = '/api/dsp/webpage/update';
export const WEBPAGE_LIST_URL = '/api/dsp/webpage/list';
export const WEBPAGE_DATA_LIST_URL = '/api/dsp/webpage/data_list';
export const WEBPAGE_ATTRIBUTION_LIST_URL = '/api/dsp/webpage/attribution_list';
export const WEBPAGE_ATTRIBUTION_GRAPH_URL = '/api/dsp/webpage/attribution_graph';

// 消息管理
export const MSG_LIST_URL = '/api/dsp/msg/list';
export const MSG_SET_STATUS_URL = '/api/dsp/msg/set_status';
export const MSG_GET_CONFIG_URL = '/api/dsp/msg/get_config';
export const MSG_SET_CONFIG_URL = '/api/dsp/msg/set_config';
// 消息订阅
export const MSG_GLOBAL_SET_CONFIG_URL = '/api/dsp/msg/set_global_config';
export const MSG_GLOBAL_GET_CONFIG_URL = '/api/dsp/msg/get_global_config';

// 网站Pixel
export const PIXEL_JS_LIST_URL = '/api/dsp/pixel/js_list';
export const PIXEL_ADD_URL = '/api/dsp/pixel/add';
export const PIXEL_UPDATE_URL = '/api/dsp/pixel/update';
export const PIXEL_LIST_URL = '/api/dsp/pixel/list';
export const PIXEL_DATA_LIST_URL = '/api/dsp/pixel/data_list';
export const PIXEL_TEST_URL = '/api/dsp/pixel/test';
export const PIXEL_TEST_DATA_LIST_URL = '/api/dsp/pixel/test_data_list';
export const PIXEL_TEST_DATA_LOG_URL = '/api/dsp/pixel/test_data_log';

// 素材管理
export const MATERIAL_ADD_URL = '/api/dsp/material/add';
export const MATERIAL_DELETE_URL = '/api/dsp/material/delete';
export const MATERIAL_UPDATE_NAME_URL = '/api/dsp/material/update_name';
export const MATERIAL_LIST_URL = '/api/dsp/material/list';

// 受众管理
export const CUSTOM_AUDIENCE_LIST_URL = '/api/dsp/custom_audience/list';
export const CUSTOM_AUDIENCE_ADD_URL = '/api/dsp/custom_audience/add';
export const CUSTOM_AUDIENCE_UPDATE_URL = '/api/dsp/custom_audience/update';
export const CUSTOM_AUDIENCE_DELETE_URL = '/api/dsp/custom_audience/delete';
export const CUSTOM_AUDIENCE_BIND_LIST_URL = '/api/dsp/custom_audience/bind_list';
export const CUSTOM_AUDIENCE_UN_BIND_URL = '/api/dsp/custom_audience/un_bind';
export const CUSTOM_AUDIENCE_LOG_LIST_URL = '/api/dsp/custom_audience/log_list';
export const CUSTOM_AUDIENCE_BIND_URL = '/api/dsp/custom_audience/bind';
export const CUSTOM_AUDIENCE_SHARE_URL = '/api/dsp/custom_audience/share';
export const CUSTOM_AUDIENCE_UNSHARE_URL = '/api/dsp/custom_audience/unshare';
export const CUSTOM_UPDATE_STATUS_URL = '/api/dsp/custom_audience/update_status';

// 商品目录
export const GOODS_CATALOG_LIST_URL = '/api/dsp/goods_catalog/list';
export const GOODS_CATALOG_ADD_URL = '/api/dsp/goods_catalog/add';
export const GOODS_CATALOG_UPDATE_STATUS_URL = '/api/dsp/goods_catalog/update_status';
export const GOODS_LIST_URL = '/api/dsp/goods/list';
export const GOODS_ADD_URL = '/api/dsp/goods/add';
export const GOODS_UPDATE_STATUS_URL = '/api/dsp/goods/update_status';
export const GOODS_MATERIAL_LIST_URL = '/api/dsp/goods_material/list';
export const GOODS_MATERIAL_UPDATE_STATUS_URL = '/api/dsp/goods_material/update_status';
export const GOODS_MATERIAL_UPDATE_URL = '/api/dsp/goods_material/update';

// 文件上传
export const FILE_TOKEN_URL = '/api/dsp/file/token';
export const FILE_ADD_URL = '/api/dsp/file/add';
export const GOOGLE_DRIVE_TO_CDN_URL = '/api/dsp/google_drive/to_cdn';

// 操作日志
export const OPERATION_LOG_LIST_URL = '/api/dsp/operation_log/list';

// 财务管理
export const FUND_STATEMENT_LIST_URL = '/api/dsp/fund/statement_list';
export const FUND_INFO_URL = '/api/dsp/fund/info';

// 日志上报
export const LOG_RECEIVE_URL = '/api/log_receive';

// 报表
export const REPORT_CREATIVE_LIST = '/api/dsp/report/creative_list';

// 线索表单
export const FORM_LIST_URL = '/api/dsp/form/list';
export const FORM_DATA_LIST_URL = '/api/dsp/form/data_list';
export const FORM_ADD_URL = '/api/dsp/form/add';
export const FORM_CONFIG_URL = '/api/dsp/form/config';
export const FORM_EXPORT_URL = '/api/dsp/form/export';
export const FORM_PREVIEW_URL = '/api/dsp/form/preview';

// 品牌广告版位列表
export const BRAND_PLACEMENT_LIST_URL = '/api/dsp/config/brand_placement_list';
